module.exports = __webpack_public_path__ + "img/16.440f3e50.jpg";